import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import PieChartIcon from '@mui/icons-material/PieChart';

const DashboardGoodsChart = ({ totalGoods }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const data = totalGoods?.totalpercentsparceldatasets?.map((item) => item.percentage);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (
      chartRef.current &&
      totalGoods &&
      totalGoods.totalpercentsparceldatasets
    ) {
      const serviceTypeNames = {
        "X": "Express",
        "P": "Economy",
        "E": "Postal"
      };

      const labels = totalGoods.totalpercentsparceldatasets.map((item) => 
        serviceTypeNames[item.service_type] || item.service_type || "Diğer"
      );
      const data = totalGoods.totalpercentsparceldatasets.map((item) => item.percentage);

      const chartData = {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: totalGoods.totalpercentsparceldatasets.map((item) =>
              getColor(item.service_type)
            ),
            borderWidth: 2,
            borderColor: '#fff',
            hoverOffset: 12
          },
        ],
      };
      
      const chartOptions = {
        aspectRatio: 1.8,
        responsive: true,
        plugins: {
          legend: {
            position: "left",
            display: true,
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 20,
              font: { size: 12, weight: '500' }
            }
          },
          tooltip: {
            backgroundColor: 'rgba(31, 41, 55, 0.95)',
            titleFont: { size: 14, weight: 'bold' },
            bodyFont: { size: 13 },
            padding: 12,
            cornerRadius: 10,
            displayColors: true,
            callbacks: {
              label: function (context) {
                const label = context.label || "";
                const value = context.parsed || 0;
                return ` ${label}: ${value.toFixed(1)}%`;
              },
            },
          },
        },
      };

      chartInstance.current = new Chart(chartRef.current, {
        type: "doughnut", // Using doughnut for a more modern look
        data: chartData,
        options: {
          ...chartOptions,
          cutout: '65%' // Hollow center for doughnut
        },
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [totalGoods]);

  // Service type'e göre renk seçimi
  const getColor = (serviceType) => {
    switch (serviceType) {
      case "E":
        return "#F765A3";
      case "X":
        return "#165BAA";
      case "P":
        return "#A155B9";
      default:
        return "rgba(0, 0, 0, 0.5)";
    }
  };

  // Check if all elements in the data array are zeros
  const areAllZeros = data?.every((value) => value === 0);

  return (
    <div className="pie-chart">
      <div className="pie-chart-header">
        <div className="chart-header-left">
          <div className="shipment-count-icon-wrapper analytics">
            <PieChartIcon />
          </div>
          <div className="chart-header-text">
            <div className="pie-text-total">Ürünlerin %'lik Dağılımı</div>
          </div>
        </div>
      </div>
      <div style={{ height: "250px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {areAllZeros ? (
          <div className="no-data-text">Gönderi ödemeniz bulunmamaktadır.</div>
        ) : (
          <canvas ref={chartRef} />
        )}
      </div>
    </div>
  );
};

export default DashboardGoodsChart;
